module.exports = ".event-software-icon {\n  border: 2px solid white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  background-color: #000; }\n"